(() => {
  // Find the product-specific JSON map (works on PDP)
  const mapEl = document.querySelector('script[id^="bp-selling-plans-"]');
  if (!mapEl) return;

  let plansByVariant;
  try {
    plansByVariant = JSON.parse(mapEl.textContent || "{}");
  } catch (e) {
    console.warn("Could not parse selling plan map JSON", e);
    return;
  }



  const select = document.getElementById("select-every");
  if (!select) return;

  const form =
    select.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!form) return;

  // Ensure there is a selling_plan input that Shopify will submit
  // (Recharge/your custom JS may already create this; we only add if missing)
  let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
  if (!sellingPlanInput) {
    sellingPlanInput = document.createElement("input");
    sellingPlanInput.type = "hidden";
    sellingPlanInput.name = "selling_plan";
    sellingPlanInput.id = "bp-selling-plan-input";
    form.appendChild(sellingPlanInput);
  }

  // Optional: if your UI has these radios, keep selling_plan blank for OTP
  const subscribeRadio = document.getElementById("subscribe");
  const otpRadio = document.getElementById("otp");

  function isOtpSelected() {
    return otpRadio && otpRadio.checked;
  }

  function syncSellingPlanInput() {
    sellingPlanInput.value = isOtpSelected() ? "" : (select.value || "");
  }

  function renderPlansForVariant(variantId) {
    const plans = plansByVariant[String(variantId)] || [];

    // Preserve current selection if still available
    const previous = select.value;

    // Rebuild options
    select.innerHTML = "";
    plans.forEach((p) => {
      const opt = document.createElement("option");
      opt.value = String(p.id);
      opt.textContent = p.name;
      select.appendChild(opt);
    });

    // Restore previous if it exists, otherwise default to first
    if (plans.some((p) => String(p.id) === String(previous))) {
      select.value = previous;
    }

    syncSellingPlanInput();
  }

  function getSelectedVariantId() {
    // Most themes keep the current variant id in a hidden input named "id"
    const idInput =
      form.querySelector('[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');

    return idInput ? idInput.value : null;
  }

  // Initial load
  const initialVariantId = getSelectedVariantId();
  if (initialVariantId) renderPlansForVariant(initialVariantId);

  // When user changes the frequency dropdown
  select.addEventListener("change", syncSellingPlanInput);

  // When user toggles subscription vs one-time
  if (subscribeRadio) subscribeRadio.addEventListener("change", syncSellingPlanInput);
  if (otpRadio) otpRadio.addEventListener("change", syncSellingPlanInput);

  // Catch common theme behavior: variant id input changes
  document.addEventListener("change", (e) => {
    if (e.target && e.target.name === "id") {
      renderPlansForVariant(e.target.value);
    }
  });

  // Catch Dawn-style event (and many modern themes)
  document.addEventListener("variant:change", (e) => {
    const id = e?.detail?.variant?.id;
    if (id) renderPlansForVariant(id);
  });
})();
